/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { Box, ButtonBase, Stack } from '@mui/material';
import type { PopperTab, PopperTabKey } from './popperTabs';

interface Props {
  tabs: Array<PopperTab>;
  value: PopperTabKey;
  onChange: (key: PopperTabKey) => void;
}

function NotificationTabs({ tabs, value, onChange }: Readonly<Props>) {
  return (
    <Stack role="tablist" direction="row" spacing={0.5} sx={{ px: 1.5, pb: 1.25 }}>
      {tabs.map(({ key, label, count }) => {
        const selected = key === value;
        return (
          <ButtonBase
            key={key}
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(key)}
            sx={(theme) => ({
              gap: 0.75,
              px: 1.25,
              py: 0.625,
              borderRadius: '8px',
              fontSize: 12,
              fontWeight: 600,
              color: selected ? 'text.primary' : 'text.secondary',
              border: `1px solid ${selected ? theme.palette.divider : 'transparent'}`,
              bgcolor: selected ? 'action.selected' : 'transparent',
              '&:hover': { bgcolor: 'action.hover' },
            })}
          >
            {label}
            {count !== undefined && (
              <Box
                component="span"
                sx={{
                  px: 0.75,
                  borderRadius: 999,
                  fontSize: 10,
                  lineHeight: '16px',
                  bgcolor: selected ? 'primary.main' : 'action.selected',
                  color: selected ? 'primary.contrastText' : 'text.secondary',
                }}
              >
                {count}
              </Box>
            )}
          </ButtonBase>
        );
      })}
    </Stack>
  );
}

export default NotificationTabs;
